import { defineStore } from "pinia";
import dayjs from "dayjs";

export const useDeviceStore = defineStore("device", {
  state: () => ({
    isAgreementReady: false,
    isOrderedDataReady: false,
    deviceID: "",
    shipName: "",
    appType: 0,
    agreementID: "-1",
    agreementDisplayID: "",
    agreementName: "",
    orderedData: {
      ukho: {
        avcs: [],
        adp: [],
        enp: [],
      },
      primar: {
        enc: [],
      },
    },
    fallbackPrimarCharts: [],
    agreements: [],
    deliveries: [],
  }),
  getters: {
    isAgreementLoaded: (state) => state.isAgreementReady,
    isOrderedDataLoaded: (state) => state.isOrderedDataReady,

    /**
     * Проверить, куплена ли карта и действительна ли она еще более 30 дней
     * @param {string} id - ID карты
     * @returns {boolean} - true если карта валидна > 30 дней
     */
    isStillValid: (state) => (id) => {
      let historyStorage = state.orderedData.primar.enc || [];
      
      let purchased = historyStorage.find(e => e.name === id) || null;
      
      // Если не найдено в основной истории, проверяем в fallback данных
      if (!purchased && state.fallbackPrimarCharts && state.fallbackPrimarCharts.length > 0) {
        purchased = state.fallbackPrimarCharts.find(e => e.name === id) || null;
      }

      if (!purchased) return false;
      
      const validDate = purchased["expiryDate"];
      if (!validDate) return false;
      
      const expiryDate = dayjs(validDate);
      const now = dayjs();
      const oneMonthLater = now.add(1, 'month');
      
      // Возвращаем true если дата истечения больше чем через месяц
      return expiryDate.isAfter(oneMonthLater);
    },

    getAgreementByDeviceID: (state) => (val) => {
      let flag = false;
      let theAgreement = null;
      state.agreements.forEach((agreement) => {
        let deviceID = agreement?.users.find((a) => a.deviceId == val);
        if (deviceID) {
          flag = true;
          theAgreement = agreement;
          return;
        }
      });
      return theAgreement;
    },

    // getAgreementByDeviceID1: (state) => {
    //     let agreement = "1234"
    //     state.agreements.forEach(item => {
    //         agreement = item.users.find((a) => a.deviceId === state.deviceId)
    //         if (agreement) {
    //             return agreement
    //         }
    //     })
    //     return agreement
    // },

    getAgreementProviderByDeviceID: (state) => (val) => {
      // return (val) => state.agreements[0]?.users.find((a) => a.deviceId === val)?.availableOrderTypes[0] ?? ''

      let theAgreement = null;
      state.agreements.forEach((agreement) => {
        let deviceID = agreement?.users.find((a) => a.deviceId == val);
        if (deviceID) {
          theAgreement = agreement.availableOrderTypes[0];
          return;
        }
      });
      return theAgreement;
    },

    isDeviceInAgreement: (state) => (val) => {
      // return (val) => (state.agreements[0]?.users.find((a) => a.deviceId === val) !== undefined)

      let flag = false;
      state.agreements.forEach((agreement) => {
        let deviceID = agreement?.users.find((a) => a.deviceId == val);
        if (deviceID) {
          flag = true;
          return;
        }
      });
      return flag;
    },

    isAgreementValid: (state) => (val) => {
      // return (val) => state.agreements[0]?.users.find((a) => a.deviceId === val)?.availableOrderTypes[0] ?? ''

      let theAgreement = null;
      state.agreements.forEach((agreement) => {
        let deviceID = agreement?.users.find((a) => a.deviceId == val);
        if (deviceID) {
          theAgreement = agreement;
          return;
        }
      });
      let valid = dayjs(theAgreement?.validTill).diff(dayjs()) > 0;
      return valid;
    },

    getAgreementID: (state) => {
      // return (val) => state.agreements[0]?.users.find((a) => a.deviceId === val)?.availableOrderTypes[0] ?? ''
      const deviceID = state.deviceID;
      let theAgreement = "-1";
      state.agreements.forEach((agreement) => {
        let user = agreement?.users.find((a) => a.deviceId == deviceID);
        if (user) {
          theAgreement = agreement.id;
          return;
        }
      });
      return theAgreement;
    },

    getAgreementCurrency: (state) => {
      // return (val) => state.agreements[0]?.users.find((a) => a.deviceId === val)?.availableOrderTypes[0] ?? ''

      if (state.agreementID === "-1") return "EUR";

      const deviceID = state.deviceID;
      let theAgreementCurrency = null;
      state.agreements.forEach((agreement) => {
        let user = agreement?.users.find((a) => a.deviceId == deviceID);
        if (user) {
          theAgreementCurrency = agreement.currency;
          return;
        }
      });
      return theAgreementCurrency;
    },

    getAgreementName: (state) => {
      // return (val) => state.agreements[0]?.users.find((a) => a.deviceId === val)?.availableOrderTypes[0] ?? ''
      const deviceID = state.deviceID;
      let theAgreementCurrency = "";
      state.agreements.forEach((agreement) => {
        let user = agreement?.users.find((a) => a.deviceId == deviceID);
        if (user) {
          theAgreementCurrency = agreement.name;
          return;
        }
      });
      return theAgreementCurrency;
    },

    getAgreementProvider: (state) => {
      const deviceID = state.deviceID;
      console.log("EEEEI1", deviceID);

      let provider = null;
      state.agreements.forEach((agreement) => {
        let user = agreement?.users.find((a) => a.deviceId === deviceID);
        if (user) {
          provider = user.availableOrderTypes[0] ?? "";
          return;
        }
      });
      console.log("EEEEI", provider);
      return provider;
    },

    getAgreementApplicationType: (state) => {
      const deviceID = state.deviceID;
      let type = null;
      state.agreements.forEach((agreement) => {
        let user = agreement?.users.find((a) => a.deviceId === deviceID);
        if (user) {
          type = user.applicationId;
          return;
        }
      });
      return type;
    },

    // getAgreementCurrency: (state) =>  {
    //     const deviceID = state.deviceID
    //     let currency = null
    //     state.agreements.forEach(agreement => {
    //         let user = agreement?.users.find((a) => a.deviceId === deviceID)
    //         if (user) {
    //             currency = user.currency
    //             return
    //         }
    //     })
    //     return currency
    // },

    // isAgreementValid: (state) => dayjs(state.agreements[0]?.validTill).diff(dayjs()) > 0 ,
    // isAgreementDays: (state) => dayjs(state.agreements[0]?.validTill).diff(dayjs()) ,
    // getAgreementID: (state) => state.agreements[0]?.id,
    // getAgreementID: (state) => state.agreementID,

    isDeviceIDExist: (state) => state.deviceID !== "",
    getDeviceID: (state) => state.deviceID,
    getAppType: (state) => state.appType,
    getShipName: (state) => state.shipName,
    getSelectedAgreementID: (state) => state.agreementID,
    getSelectedAgreementDisplayID: (state) => state.agreementDisplayID,
    getSelectedAgreementName: (state) => state.agreementName,
    // getLatestLog: (state) => state.logbook[state.logbook.length - 1]
    // getLatestLog: (state) => {
    //     return () => state.logbook[state.logbook.length - 1]
    // },
    getDeliveries: (state) => state.deliveries,
    getDeliveriesCount: (state) => state.deliveries.length,
  },
  actions: {
    addAgreements(val) {
      this.agreements = val;
      this.isAgreementReady = true;
    },
    selectDevice(val) {
      this.deviceID = val;
    },
    selectDeviceWithDetails(deviceId, shipName, agreement) {
      this.deviceID = deviceId;
      this.shipName = shipName || "";
      this.agreementID = agreement?.id || "-1";
      this.agreementDisplayID = agreement?.displayId || "";
      this.agreementName = agreement?.name || "";
    },
    addOrdersHistoryAVCS(val) {
      this.orderedData.ukho.avcs = val || [];
    },
    addOrdersHistoryPrimar(val) {
      this.orderedData.primar.enc = val || [];
    },
    addFallbackPrimarCharts(val) {
      this.fallbackPrimarCharts = val || [];
    },
    addDeliveries(val) {
      this.deliveries = val;
    },
    reset() {
      this.deviceID = "";
      this.shipName = "";
      this.agreementID = "";
      this.agreementDisplayID = "";
      this.agreementName = "";
      this.isAgreementReady = false;
      this.isOrderedDataReady = false;
      this.orderedData = {
        ukho: {
          avcs: [],
          adp: [],
          enp: [],
        },
        primar: {
          enc: [],
        },
      };
      this.agreements = [];
      this.deliveries = [];
    },
  },
  persist: false,
});
